import React from 'react';
import IntegrationConfigurationForm from "./IntegrationConfigurationForm";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";

class IntegrationConfigurationFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>];
    return (
        <Page title="Configuraçãoes de Integração" breadcrumbs={breadcrumbs}>
          <IntegrationConfigurationForm match={match} history={history}/>
        </Page>
    );
  }
}

export default IntegrationConfigurationFormPage;



// WEBPACK FOOTER //
// ./src/integration/configuration/IntegrationConfigurationFormPage.js